"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTitle = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const StyledCardTitleTypography = (0, styled_components_1.default)(core_1.Typography) `
  display: flex;
  align-items: center;
  /* margin-bottom: 10px; */
  padding: 16px 16px 0 16px;
  .icon,
  .MuiSvgIcon-root {
    margin-right: 10px;
  }
`;
function CardTitle(props) {
    const { children } = props;
    return (react_1.default.createElement(StyledCardTitleTypography, Object.assign({ className: 'card-title', variant: 'overline' }, props), children));
}
exports.CardTitle = CardTitle;
exports.default = CardTitle;
//# sourceMappingURL=CardTitle.js.map